export default function MiniHeader({ title }) {
    return (
        <h6 style={{ color: 'grey', margin: 0, marginBottom: 4, fontSize: 12 }}>{title.toUpperCase()}</h6>
    )
}